import { ContentDisplay, Grid, Typography, useTheme } from '../../../base';

interface IContentAreaProps {
    content: {
        title: string;
        content: string;
    };
}
const ContentArea = (props: IContentAreaProps) => {
    const { content } = props;
    const theme = useTheme();

    return (
        <>
            <Grid
                container
                display="flex"
                alignItems="center"
                gap={1}
                sx={{ paddingBottom: theme.spacing(1.25) }}
            >
                <Typography variant={'h6'}>{content.title}</Typography>
            </Grid>
            <ContentDisplay content={content.content} compact />
        </>
    );
};

export default ContentArea;
